import { render, staticRenderFns } from "./addChangeAlert.vue?vue&type=template&id=8803914e&scoped=true&"
import script from "./addChangeAlert.vue?vue&type=script&lang=js&"
export * from "./addChangeAlert.vue?vue&type=script&lang=js&"
import style0 from "./addChangeAlert.vue?vue&type=style&index=0&id=8803914e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8803914e",
  null
  
)

export default component.exports